import { createSignal } from '@verclam/pulsar';

/** `index` is the rank of the edited field in the draft, or `null` when composing a new one. */
export type FieldSidebarContext = { readonly index: number | null };

const fieldSidebarSignal = createSignal<FieldSidebarContext | null>(null);

export const openNewFieldInSidebar = (): void => {
	fieldSidebarSignal.value = { index: null };
};

export const editFieldInSidebar = (index: number): void => {
	fieldSidebarSignal.value = { index };
};

export const closeFieldSidebar = (): void => {
	fieldSidebarSignal.value = null;
};

export default fieldSidebarSignal;
